/** Clases canónicas de botones compactos (toolbar y CompactCard.actions). */
export const COMPACT_TOOLBAR_BUTTON_BASE = "compact-toolbar-btn h-6";

export const COMPACT_TOOLBAR_BUTTON_SECONDARY = `${COMPACT_TOOLBAR_BUTTON_BASE} compact-toolbar-btn-secondary`;

export const COMPACT_TOOLBAR_BUTTON_PRIMARY = `${COMPACT_TOOLBAR_BUTTON_BASE} compact-toolbar-btn-primary`;

export const COMPACT_TOOLBAR_BUTTON_DANGER = `${COMPACT_TOOLBAR_BUTTON_BASE} compact-toolbar-btn-danger`;
